import { Box, Flex, Collapse, ScaleFade } from "@chakra-ui/react";
import { SearchSharedDocs } from "./SearchSharedDocs";
import SharedDocsOwnerFilter from "./SharedDocsOwnerFilter";
import { IoMdAddCircle } from "react-icons/io";
import { CreateSharedDoc } from "./CreateSharedDoc";
import { SharedDocsList } from "./SharedDocsList";
import { EmptyTable } from "./EmptyTable";
import LaunchdeckButton from "../../global/components/helper-components/components/LaunchdeckButton";

export const DisplaySharedDocsContent = ({
  dsrId,
  sharedDocsArray,
  searchTextInput,
  clearSearch,
  onSearchChange,
  handleSearch,
  isMobileView,
  showAddDocumentForm,
  handleFilterOwner,
  handleSharedDocOrderChange,
  dsrTeamMembers,
  setShowAddDocumentForm,
  showDeleteSpinner,
  handleDeleteSharedDoc,
  setShowDeleteSpinner,
  showPopoverDocId,
  setShowPopoverDocId,
  isOpen,
  onOpen,
  onClose,
  displaySignupPrompt,
  handleOpenSignupOrLoginModal,
  handleEditSharedDoc,
  isDsrAdmin,
  isRoomTemplate,
  isPagePreviewMode,
  handleShowPreviewPrompt
}) => {

  const isValidSharedDocsArrayAndNotEmpty = Array.isArray(sharedDocsArray) && sharedDocsArray?.length > 0;
  const handleClickAddDocumentButton = () => {
    displaySignupPrompt
      ? handleOpenSignupOrLoginModal()
      : isPagePreviewMode ?
        handleShowPreviewPrompt()
        : setShowAddDocumentForm(!showAddDocumentForm)
  }

  return (
    <>
      {showAddDocumentForm ?
        <Flex opacity={"1.0"} w='100%'>
          <Collapse in={true} animateOpacity style={{ width: "100%" }}>
            <CreateSharedDoc
              dsrId={dsrId}
              isMobileView={isMobileView}
              setShowAddDocumentForm={setShowAddDocumentForm}
              showAddDocummentForm={showAddDocumentForm}
            />
          </Collapse>
        </Flex>
        :
        <>
          <Flex w="100%" direction={["column", "row"]} align='center' mt="2em" mb='1.5em' gap={12}>
            <Box flex={['1', '8']} w='100%'>
              <SearchSharedDocs
                isMobileView={isMobileView}
                searchTextInput={searchTextInput}
                clearSearch={clearSearch}
                onSearchChange={onSearchChange}
                handleSearch={handleSearch}
              />
            </Box>

            <Flex
              direction={isMobileView && "column"}
              flex={['1', '1']}
              w="100%"
              align="center"
              justify="center"
              display={showAddDocumentForm ? "none" : "block"}
            >
              {!isRoomTemplate && !isMobileView &&
                <SharedDocsOwnerFilter
                  handleFilterOwner={handleFilterOwner}
                  dsrTeamMembers={dsrTeamMembers}
                  sharedDocs={sharedDocsArray}
                  isMobileView={isMobileView}
                />
              }

              {isMobileView && !showAddDocumentForm &&
                <Flex mb="1em" w='100%'>
                  <LaunchdeckButton
                    w='100%'
                    bg='brand.500'
                    color='white'
                    py='0.4em'
                    onClick={handleClickAddDocumentButton}
                  >
                    <Flex gap={4} justify='center'>
                      <IoMdAddCircle font-size='1.5em' />
                      New
                    </Flex>
                  </LaunchdeckButton>
                </Flex>
              }


            </Flex>
          </Flex>

          <ScaleFade initialScale={0.9} in={true}>
            {isValidSharedDocsArrayAndNotEmpty ? (
              <SharedDocsList
                isMobileView={isMobileView}
                isDsrAdmin={isDsrAdmin}
                sharedDocsArray={sharedDocsArray}
                showDeleteSpinner={showDeleteSpinner}
                showPopoverDocId={showPopoverDocId}
                setShowPopoverDocId={setShowPopoverDocId}
                handleSharedDocOrderChange={handleSharedDocOrderChange}
                handleDeleteSharedDoc={handleDeleteSharedDoc}
                setShowDeleteSpinner={setShowDeleteSpinner}
                isOpen={isOpen}
                onOpen={onOpen}
                onClose={onClose}
                handleEditSharedDoc={handleEditSharedDoc}
                handleClickAddDocumentButton={handleClickAddDocumentButton}
              />
            ) : (
              <EmptyTable
                searchTextInput={searchTextInput}
                clearSearch={clearSearch}
              />
            )}
          </ScaleFade>
        </>

      }
    </>
  );
};
